import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("grp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("grp_token", t);
  else localStorage.removeItem("grp_token");
};

export const getToken = () => localStorage.getItem("grp_token");

export const pdfUrl = (path) => {
  const token = getToken();
  return `${BASE}/api${path}${path.includes("?") ? "&" : "?"}_t=${encodeURIComponent(token || "")}`;
};

export const formatApiError = (err) => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Terjadi kesalahan";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  if (typeof d === "object") return d.message || JSON.stringify(d);
  return String(d);
};
